import React from 'react';
import PropTypes from 'prop-types';
import './css/TopEventsCards.css';

const TopEventsCards = ({ events, formatCurrency }) => {
  return (
    <section className="top-events-cards-section">
      <h3>Top Selling Events</h3>
      <div className="events-cards-grid">
        {events.map((event, index) => (
          <div key={index} className="top-event-card">
            <div className="event-card-header">
              <h4>{event.name}</h4>
              <span className="event-category-badge">{event.category}</span>
            </div>
            <div className="event-card-metrics">
              <div className="metric-row">
                <span className="metric-label">Tickets:</span>
                <span className="metric-value">{event.tickets.toLocaleString()}</span>
              </div>
              <div className="metric-row">
                <span className="metric-label">Revenue:</span>
                <span className="metric-value">{formatCurrency(event.revenue)}</span>
              </div>
              <div className="metric-row">
                <span className="metric-label">Date:</span>
                <span className="metric-value">{event.date}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

TopEventsCards.propTypes = {
  events: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      tickets: PropTypes.number.isRequired,
      revenue: PropTypes.number.isRequired,
      category: PropTypes.string.isRequired,
      date: PropTypes.string.isRequired
    })
  ).isRequired,
  formatCurrency: PropTypes.func.isRequired
};

export default TopEventsCards;
